/*
 * Copyright (c) New Cloud Technologies, Ltd., 2013-2020
 *
 * You can not use the contents of the file in any way without New Cloud Technologies, Ltd. written permission.
 * To obtain such a permit, you should contact New Cloud Technologies, Ltd. at http://ncloudtech.com/contact.html
 *
 */

function checkSearchHasField(field, search) {
    if (!(search && search.includes('?'))) return false;

    const pairs = search.slice(1).split('&');

    return pairs.some((pair) => pair.split('=')[0] === field);
}

function getFieldFromSearch(field, search) {
    const pairs = search.slice(1).split('&');

    return pairs.find((pair) => pair.split('=')[0] === field)?.split('=')[1];
}

export function getFileNameFromSearch(search) {
    const fieldName = 'document';
    if (checkSearchHasField(fieldName, search)) {
        return getFieldFromSearch(fieldName, search);
    }
}

export function getReadOnlyFromSearch(search) {
    const fieldName = 'readonly';
    if (checkSearchHasField(fieldName, search)) {
        return getFieldFromSearch(fieldName, search) === 'true';
    }
}

export function getLanguageCodeFromSearch(search) {
    const fieldName = 'language';
    if (checkSearchHasField(fieldName, search)) {
        return getFieldFromSearch(fieldName, search);
    }
}

export function getFileByAJAX(fileNameFromSearch) {
    //    return fetch(`${window.location.origin}/demo/files/${fileNameFromSearch}`)
    return fetch(`files/${fileNameFromSearch}`)
        .then((response) => response.blob())
        .then((blob) => blob.arrayBuffer());
}
